export default __webpack_public_path__ + "static/media/Loader-Web-Gif.4f86e0a1.gif";